import { Button, Group } from '@mantine/core';

const defaultWeeksDays = [
  { name: 'Sun', value: 0 },
  { name: 'Mon', value: 1 },
  { name: 'Tue', value: 2 },
  { name: 'Wed', value: 3 },
  { name: 'Thu', value: 4 },
  { name: 'Fri', value: 5 },
  { name: 'Sat', value: 6 },
];

const WeekdaySelector = ({ values, setValues }) => {
  return (
    <Group gap={0}>
      {defaultWeeksDays.map((item, index) => (
        <Button
          key={item.value}
          variant={values?.includes(item.value) ? 'filled' : 'outline'}
          onClick={() => {
            if (values.includes(item.value)) {
              setValues(values.filter((element) => element !== item.value));
            } else {
              setValues([...values, item.value]);
            }
          }}
          style={{
            borderRadius: index === 0 ? '4px 0 0 4px' : index === defaultWeeksDays.length - 1 ? '0 4px 4px 0' : 0,
            marginLeft: index > 0 ? -1 : 0,
          }}
        >
          {item.name}
        </Button>
      ))}
    </Group>
  );
};

export default WeekdaySelector;
